import { render, staticRenderFns } from "./ClassFormModal.vue?vue&type=template&id=ab28101a&scoped=true&"
import script from "./ClassFormModal.vue?vue&type=script&lang=js&"
export * from "./ClassFormModal.vue?vue&type=script&lang=js&"
import style0 from "./ClassFormModal.vue?vue&type=style&index=0&id=ab28101a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab28101a",
  null
  
)

export default component.exports